<template>
  <div class="container">
    <div class="top">
      <p class="total">
        共 <label>{{ total }}</label> 条记录
      </p>
      <div class="search">
        <el-input
          v-model="keyWords"
          placeholder="请输入刊名、ISSN、出版社"
          @keyup.enter.native="toSearch"
          clearable
        ></el-input>
        <span class="search_img" @click="toSearch">
          <img src="../../assets/images/search_icon.png" />
        </span>
      </div>
    </div>

    <div class="right-item">
      <ul>
        <li class="flex" v-for="(item, index) in list" :key="index">
          <span class="index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
          <div class="img" @click="toDetail(item)">
            <img :src="item.cover ? imgUrl + item.cover : defaultImg" />
          </div>
          <div class="right-info">
            <p v-if="item.name">
              <span @click="toDetail(item)" v-html="item.name"></span
              ><i v-show="item.paperCount != 0" class="addicon"></i>
            </p>
            <p v-if="item.issn">ISSN: <span v-html="item.issn"></span></p>
            <!-- <p v-if="item.pissn">PISSN: <span v-html="item.pissn"></span></p> -->
            <!-- <p v-if="item.eissn">EISSN: <span v-html="item.eissn"></span></p> -->
            <p v-if="item.publisherName">
              出版社: <span v-html="item.publisherName"></span>
            </p>
            <a @click="removeCollect(index)">取消收藏</a>
            <a v-if="item.subscribe === 0" @click="addSubscribe(index)">订阅</a>
            <a v-if="item.subscribe === 1" @click="removeSubscribe(index)"
              >取消订阅</a
            >
          </div>
        </li>
      </ul>
      <div class="noData" v-if="total <= 0">
        <img src="../../assets/images/noData.png" />
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        hide-on-single-page
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import baseurl from "../../api/baseurl";
export default {
  name: "myArticle",
  data() {
    return {
      total: 1,
      pageSize: 10,
      pageNo: 1,
      list: [],
      keyWords: "",
      defaultImg: require("../../assets/images/default.png"),
      imgUrl: "",
    };
  },
  mounted() {
    this.imgUrl = baseurl.fileUrl;
    this.getList();
  },
  methods: {
    getString(data) {
      if (data) {
        return data.toString().split(",").join(" ; ");
      }
    },
    getList() {
      let postBody = {
        keyWords: this.keyWords,
        type: 1,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      this.$http({
        url: "api/v1/usershare/list",
        method: "POST",
        data: postBody,
      }).then((res) => {
        this.total = res.total;
        this.list = res.rows;
      });
    },
    //订阅取消订阅
    addSubscribe(index) {
      this.$http({
        url: `api/v1/usershare/deal/subscribe?shareId=${this.list[index].shareId}`,
        method: "get",
      }).then((res) => {
        if (res.code == 200) {
          this.pageNo = 1;
          this.$message.success("订阅成功");
          this.getList();
        }
      });
    },
    removeSubscribe(index) {
      this.$confirm("是否要取消订阅?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: `api/v1/usershare/deal/subscribe?shareId=${this.list[index].shareId}`,
          method: "get",
        }).then((res) => {
          if (res.code == 200) {
            this.pageNo = 1;
            this.$message.success("取消订阅成功");
            this.getList();
          }
        });
      });
    },
    removeCollect(index) {
      this.$confirm("是否要取消收藏?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let postBody = {
          outSid: this.list[index].sid,
          type: 1,
        };
        this.$http({
          url: `api/v1/usershare/collect`,
          method: "POST",
          data: postBody,
        }).then((res) => {
          if (res.code == 200) {
            this.pageNo = 1;
            this.$message.success("取消收藏成功");
            this.getList();
          }
        });
      });
    },
    toDetail(item) {
      if (item.paperCount != 0) {
        this.clickstate(item.shareId);
      }
      let _url = this.$router.resolve({
        path: "/homeDetail",
        query: { sid: item.sid },
      });
      window.open(_url.href, "_self");
    },
    //变更状态是否有新增
    clickstate(id) {
      this.$http({
        url: `api//v1/usershare/record/click?shareId=` + id,
        method: "get",
      }).then((res) => {
        if (res.code == 200) {
          console.log("状态修改");
        }
      });
    },
    toSearch() {
      this.pageNo = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  .addicon {
    background: url("../../assets/images/addicon.png") no-repeat;
    position: absolute;
    margin-top: 5px;
    margin-left: 9px;
    width: 24px;
    height: 14px;
  }
  .right-item {
    background: #fff;
    margin-top: 20px;
    padding: 0 20px;
    ul {
      li {
        padding: 20px 0;
        border-bottom: 1px dashed #eeeeee;
        .index {
          width: 50px;
          line-height: 30px;
        }
        .img {
          width: 160px;
          height: 160px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          border: 1px solid #eeeeee;
          cursor: pointer;
          margin-right: 20px;
          img {
            max-width: 158px;
            max-height: 158px;
          }
        }
        .right-info {
          color: #666666;
          flex: 1;
          min-width: 0;
          p {
            line-height: 25px;
            &:nth-of-type(1) {
              color: #333;
              font-size: 18px;
              font-weight: bold;
              margin-bottom: 10px;
              cursor: pointer;
            }
          }
          a {
            border-radius: 4px;
            border: 1px solid #2d8cf0;
            color: #2d8cf0;
            font-size: 14px;
            padding: 5px 15px;
            margin-top: 10px;
            display: inline-block;
            margin-right: 15px;
          }
          .el-button {
            margin-top: 10px;
          }
        }
        &:hover {
          .right-info {
            p {
              &:nth-of-type(1) {
                background-image: linear-gradient(to right, #006eb3, #2d8cf0);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }
          }
        }
      }
    }
  }
  .top {
    display: flex;
    align-items: center;
    padding: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    .total {
      label {
        color: #2d8cf0;
      }
    }
    .search {
      display: flex;
      align-items: center;
      background: #fff;
      border: 1px solid #cccccc;
      margin-left: auto;
      ::v-deep .el-input__inner {
        border: none;
        border-radius: 0;
        height: 30px;
        line-height: 30px;
      }
      ::v-deep .el-input__icon {
        line-height: 30px;
      }
      .el-input {
        width: 280px;
      }
      .search_img {
        width: 40px;
        height: 30px;
        background: #2d8cf0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
}
</style>
